package com.nonopn.skywatcher.common.app.navigation.scaffold

import androidx.compose.material.Surface
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.common.app.home.LocalAppBarProvider
import com.nonopn.skywatcher.common.app.home.LocalMenuState
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.utils.LocalWindow
import com.nonopn.skywatcher.design.widgets.TopAppBarExtended
import eu.codlab.navigation.LocalNavigator
import kotlinx.coroutines.launch

@Composable
fun TopBarWrapper(disableMenuInBigScreen: Boolean = false) {
    val scaffold = LocalMenuState.current
    val appModel = LocalAppBarProvider.current
    val navigator = LocalNavigator.current

    val scope = rememberCoroutineScope()

    val state by appModel.states.collectAsState()
    val navigatorState by navigator.states.collectAsState()

    val isScreenExpanded = LocalWindow.current.isScreenExpanded()

    if (state.appBarState is AppBarState.Hidden) {
        return
    }

    Surface(elevation = 8.dp) {
        TopAppBarExtended(
            title = state.appBarState.showTitle(),
            topSpacer = true,
            canGoBack = navigatorState.canGoBack,
            isScreenExpanded = !disableMenuInBigScreen && isScreenExpanded,
            appModel = appModel
        ) {
            if (navigatorState.canGoBack) {
                navigator.goBack()
                return@TopAppBarExtended
            }

            scope.launch {
                scaffold?.drawerState?.let {
                    if (it.isOpen) {
                        it.close()
                    } else {
                        it.open()
                    }
                }
            }
        }
    }
}
